import { Box } from '@mui/material';
import { ReactNode } from 'react';
import { ICON_PX } from '~/theme/iconSizes';

/**
 * An icon on a tinted rounded square, the mark that opens a panel or
 * dialog header. One size, so headers cannot drift on it.
 */
export default function IconTile({ children }: { children: ReactNode }) {
    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 28,
                height: 28,
                borderRadius: 1,
                bgcolor: 'action.selected',
                color: 'primary.light',
                flexShrink: 0,
                '& svg': { width: ICON_PX, height: ICON_PX },
            }}
        >
            {children}
        </Box>
    );
}
